export default __webpack_public_path__ + "static/media/UEFull_Whiteback.1d3038a1.png";